import oe from "axios";
var Dt = typeof global == "object" && global && global.Object === Object && global, ie = typeof self == "object" && self && self.Object === Object && self, m = Dt || ie || Function("return this")(), E = m.Symbol, Lt = Object.prototype, se = Lt.hasOwnProperty, ce = Lt.toString, N = E ? E.toStringTag : void 0;
function ue(t) {
  var e = se.call(t, N), r = t[N];
  try {
    t[N] = void 0;
    var n = !0;
  } catch (i) {
  }
  var s = ce.call(t);
  return n && (e ? t[N] = r : delete t[N]), s;
}
var fe = Object.prototype, le = fe.toString;
function pe(t) {
  return le.call(t);
}
var ge = "[object Null]", de = "[object Undefined]", gt = E ? E.toStringTag : void 0;
function K(t) {
  return t == null ? t === void 0 ? de : ge : gt && gt in Object(t) ? ue(t) : pe(t);
}
function z(t) {
  return t != null && typeof t == "object";
}
var ot = Array.isArray;
function H(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var he = "[object AsyncFunction]", be = "[object Function]", ye = "[object GeneratorFunction]", _e = "[object Proxy]";
function Ut(t) {
  if (!H(t))
    return !1;
  var e = K(t);
  return e == be || e == ye || e == he || e == _e;
}
var Q = m["__core-js_shared__"], dt = function() {
  var t = /[^.]+$/.exec(Q && Q.keys && Q.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function Te(t) {
  return !!dt && dt in t;
}
var ve = Function.prototype, je = ve.toString;
function P(t) {
  if (t != null) {
    try {
      return je.call(t);
    } catch (e) {
    }
    try {
      return t + "";
    } catch (e) {
    }
  }
  return "";
}
var me = /[\\^$.*+?()[\]{}|]/g, $e = /^\[object .+?Constructor\]$/, Oe = Function.prototype, we = Object.prototype, Ae = Oe.toString, Se = we.hasOwnProperty, Pe = RegExp(
  "^" + Ae.call(Se).replace(me, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Ie(t) {
  if (!H(t) || Te(t))
    return !1;
  var e = Ut(t) ? Pe : $e;
  return e.test(P(t));
}
function xe(t, e) {
  return t == null ? void 0 : t[e];
}
function I(t, e) {
  var r = xe(t, e);
  return Ie(r) ? r : void 0;
}
var tt = I(m, "WeakMap"), ht = Object.create, Ce = /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (!H(e))
      return {};
    if (ht)
      return ht(e);
    t.prototype = e;
    var r = new t();
    return t.prototype = void 0, r;
  };
}();
function Ee(t, e) {
  var r = -1, n = t.length;
  for (e || (e = Array(n)); ++r < n; )
    e[r] = t[r];
  return e;
}
var bt = function() {
  try {
    var t = I(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch (e) {
  }
}();
function Me(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n && e(t[r], r, t) !== !1; )
    ;
  return t;
}
var Fe = 9007199254740991, De = /^(?:0|[1-9]\d*)$/;
function Le(t, e) {
  var r = typeof t;
  return e = e == null ? Fe : e, !!e && (r == "number" || r != "symbol" && De.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
function Nt(t, e, r) {
  e == "__proto__" && bt ? bt(t, e, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : t[e] = r;
}
function Bt(t, e) {
  return t === e || t !== t && e !== e;
}
var Ue = Object.prototype, Ne = Ue.hasOwnProperty;
function Gt(t, e, r) {
  var n = t[e];
  (!(Ne.call(t, e) && Bt(n, r)) || r === void 0 && !(e in t)) && Nt(t, e, r);
}
function W(t, e, r, n) {
  var s = !r;
  r || (r = {});
  for (var i = -1, o = e.length; ++i < o; ) {
    var f = e[i], l = n ? n(r[f], t[f], f, r, t) : void 0;
    l === void 0 && (l = t[f]), s ? Nt(r, f, l) : Gt(r, f, l);
  }
  return r;
}
var Be = 9007199254740991;
function Rt(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= Be;
}
function qt(t) {
  return t != null && Rt(t.length) && !Ut(t);
}
var Ge = Object.prototype;
function it(t) {
  var e = t && t.constructor, r = typeof e == "function" && e.prototype || Ge;
  return t === r;
}
function Re(t, e) {
  for (var r = -1, n = Array(t); ++r < t; )
    n[r] = e(r);
  return n;
}
var qe = "[object Arguments]";
function yt(t) {
  return z(t) && K(t) == qe;
}
var Kt = Object.prototype, Ke = Kt.hasOwnProperty, ze = Kt.propertyIsEnumerable, He = yt(/* @__PURE__ */ function() {
  return arguments;
}()) ? yt : function(t) {
  return z(t) && Ke.call(t, "callee") && !ze.call(t, "callee");
};
function Ve() {
  return !1;
}
var zt = typeof exports == "object" && exports && !exports.nodeType && exports, _t = zt && typeof module == "object" && module && !module.nodeType && module, Je = _t && _t.exports === zt, Tt = Je ? m.Buffer : void 0, We = Tt ? Tt.isBuffer : void 0, Ht = We || Ve, Ye = "[object Arguments]", Xe = "[object Array]", Ze = "[object Boolean]", Qe = "[object Date]", ke = "[object Error]", tr = "[object Function]", er = "[object Map]", rr = "[object Number]", nr = "[object Object]", ar = "[object RegExp]", or = "[object Set]", ir = "[object String]", sr = "[object WeakMap]", cr = "[object ArrayBuffer]", ur = "[object DataView]", fr = "[object Float32Array]", lr = "[object Float64Array]", pr = "[object Int8Array]", gr = "[object Int16Array]", dr = "[object Int32Array]", hr = "[object Uint8Array]", br = "[object Uint8ClampedArray]", yr = "[object Uint16Array]", _r = "[object Uint32Array]", u = {};
u[fr] = u[lr] = u[pr] = u[gr] = u[dr] = u[hr] = u[br] = u[yr] = u[_r] = !0;
u[Ye] = u[Xe] = u[cr] = u[Ze] = u[ur] = u[Qe] = u[ke] = u[tr] = u[er] = u[rr] = u[nr] = u[ar] = u[or] = u[ir] = u[sr] = !1;
function Tr(t) {
  return z(t) && Rt(t.length) && !!u[K(t)];
}
function st(t) {
  return function(e) {
    return t(e);
  };
}
var Vt = typeof exports == "object" && exports && !exports.nodeType && exports, G = Vt && typeof module == "object" && module && !module.nodeType && module, vr = G && G.exports === Vt, k = vr && Dt.process, M = function() {
  try {
    var t = G && G.require && G.require("util").types;
    return t || k && k.binding && k.binding("util");
  } catch (e) {
  }
}(), vt = M && M.isTypedArray, jr = vt ? st(vt) : Tr, mr = Object.prototype, $r = mr.hasOwnProperty;
function Jt(t, e) {
  var r = ot(t), n = !r && He(t), s = !r && !n && Ht(t), i = !r && !n && !s && jr(t), o = r || n || s || i, f = o ? Re(t.length, String) : [], l = f.length;
  for (var g in t)
    (e || $r.call(t, g)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
    Le(g, l))) && f.push(g);
  return f;
}
function Wt(t, e) {
  return function(r) {
    return t(e(r));
  };
}
var Or = Wt(Object.keys, Object), wr = Object.prototype, Ar = wr.hasOwnProperty;
function Sr(t) {
  if (!it(t))
    return Or(t);
  var e = [];
  for (var r in Object(t))
    Ar.call(t, r) && r != "constructor" && e.push(r);
  return e;
}
function ct(t) {
  return qt(t) ? Jt(t) : Sr(t);
}
function Pr(t) {
  var e = [];
  if (t != null)
    for (var r in Object(t))
      e.push(r);
  return e;
}
var Ir = Object.prototype, xr = Ir.hasOwnProperty;
function Cr(t) {
  if (!H(t))
    return Pr(t);
  var e = it(t), r = [];
  for (var n in t)
    n == "constructor" && (e || !xr.call(t, n)) || r.push(n);
  return r;
}
function ut(t) {
  return qt(t) ? Jt(t, !0) : Cr(t);
}
var R = I(Object, "create");
function Er() {
  this.__data__ = R ? R(null) : {}, this.size = 0;
}
function Mr(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var Fr = "__lodash_hash_undefined__", Dr = Object.prototype, Lr = Dr.hasOwnProperty;
function Ur(t) {
  var e = this.__data__;
  if (R) {
    var r = e[t];
    return r === Fr ? void 0 : r;
  }
  return Lr.call(e, t) ? e[t] : void 0;
}
var Nr = Object.prototype, Br = Nr.hasOwnProperty;
function Gr(t) {
  var e = this.__data__;
  return R ? e[t] !== void 0 : Br.call(e, t);
}
var Rr = "__lodash_hash_undefined__";
function qr(t, e) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = R && e === void 0 ? Rr : e, this;
}
function S(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
S.prototype.clear = Er;
S.prototype.delete = Mr;
S.prototype.get = Ur;
S.prototype.has = Gr;
S.prototype.set = qr;
function Kr() {
  this.__data__ = [], this.size = 0;
}
function Y(t, e) {
  for (var r = t.length; r--; )
    if (Bt(t[r][0], e))
      return r;
  return -1;
}
var zr = Array.prototype, Hr = zr.splice;
function Vr(t) {
  var e = this.__data__, r = Y(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : Hr.call(e, r, 1), --this.size, !0;
}
function Jr(t) {
  var e = this.__data__, r = Y(e, t);
  return r < 0 ? void 0 : e[r][1];
}
function Wr(t) {
  return Y(this.__data__, t) > -1;
}
function Yr(t, e) {
  var r = this.__data__, n = Y(r, t);
  return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
}
function $(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
$.prototype.clear = Kr;
$.prototype.delete = Vr;
$.prototype.get = Jr;
$.prototype.has = Wr;
$.prototype.set = Yr;
var q = I(m, "Map");
function Xr() {
  this.size = 0, this.__data__ = {
    hash: new S(),
    map: new (q || $)(),
    string: new S()
  };
}
function Zr(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function X(t, e) {
  var r = t.__data__;
  return Zr(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
function Qr(t) {
  var e = X(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function kr(t) {
  return X(this, t).get(t);
}
function tn(t) {
  return X(this, t).has(t);
}
function en(t, e) {
  var r = X(this, t), n = r.size;
  return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}
function F(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
F.prototype.clear = Xr;
F.prototype.delete = Qr;
F.prototype.get = kr;
F.prototype.has = tn;
F.prototype.set = en;
function Yt(t, e) {
  for (var r = -1, n = e.length, s = t.length; ++r < n; )
    t[s + r] = e[r];
  return t;
}
var rn = Wt(Object.getPrototypeOf, Object);
const Xt = rn;
function nn() {
  this.__data__ = new $(), this.size = 0;
}
function an(t) {
  var e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
function on(t) {
  return this.__data__.get(t);
}
function sn(t) {
  return this.__data__.has(t);
}
var cn = 200;
function un(t, e) {
  var r = this.__data__;
  if (r instanceof $) {
    var n = r.__data__;
    if (!q || n.length < cn - 1)
      return n.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new F(n);
  }
  return r.set(t, e), this.size = r.size, this;
}
function D(t) {
  var e = this.__data__ = new $(t);
  this.size = e.size;
}
D.prototype.clear = nn;
D.prototype.delete = an;
D.prototype.get = on;
D.prototype.has = sn;
D.prototype.set = un;
function fn(t, e) {
  return t && W(e, ct(e), t);
}
function ln(t, e) {
  return t && W(e, ut(e), t);
}
var Zt = typeof exports == "object" && exports && !exports.nodeType && exports, jt = Zt && typeof module == "object" && module && !module.nodeType && module, pn = jt && jt.exports === Zt, mt = pn ? m.Buffer : void 0, $t = mt ? mt.allocUnsafe : void 0;
function gn(t, e) {
  if (e)
    return t.slice();
  var r = t.length, n = $t ? $t(r) : new t.constructor(r);
  return t.copy(n), n;
}
function dn(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, s = 0, i = []; ++r < n; ) {
    var o = t[r];
    e(o, r, t) && (i[s++] = o);
  }
  return i;
}
function Qt() {
  return [];
}
var hn = Object.prototype, bn = hn.propertyIsEnumerable, Ot = Object.getOwnPropertySymbols, ft = Ot ? function(t) {
  return t == null ? [] : (t = Object(t), dn(Ot(t), function(e) {
    return bn.call(t, e);
  }));
} : Qt;
function yn(t, e) {
  return W(t, ft(t), e);
}
var _n = Object.getOwnPropertySymbols, kt = _n ? function(t) {
  for (var e = []; t; )
    Yt(e, ft(t)), t = Xt(t);
  return e;
} : Qt;
function Tn(t, e) {
  return W(t, kt(t), e);
}
function te(t, e, r) {
  var n = e(t);
  return ot(t) ? n : Yt(n, r(t));
}
function vn(t) {
  return te(t, ct, ft);
}
function jn(t) {
  return te(t, ut, kt);
}
var et = I(m, "DataView"), rt = I(m, "Promise"), nt = I(m, "Set"), wt = "[object Map]", mn = "[object Object]", At = "[object Promise]", St = "[object Set]", Pt = "[object WeakMap]", It = "[object DataView]", $n = P(et), On = P(q), wn = P(rt), An = P(nt), Sn = P(tt), A = K;
(et && A(new et(new ArrayBuffer(1))) != It || q && A(new q()) != wt || rt && A(rt.resolve()) != At || nt && A(new nt()) != St || tt && A(new tt()) != Pt) && (A = function(t) {
  var e = K(t), r = e == mn ? t.constructor : void 0, n = r ? P(r) : "";
  if (n)
    switch (n) {
      case $n:
        return It;
      case On:
        return wt;
      case wn:
        return At;
      case An:
        return St;
      case Sn:
        return Pt;
    }
  return e;
});
const lt = A;
var Pn = Object.prototype, In = Pn.hasOwnProperty;
function xn(t) {
  var e = t.length, r = new t.constructor(e);
  return e && typeof t[0] == "string" && In.call(t, "index") && (r.index = t.index, r.input = t.input), r;
}
var xt = m.Uint8Array;
function pt(t) {
  var e = new t.constructor(t.byteLength);
  return new xt(e).set(new xt(t)), e;
}
function Cn(t, e) {
  var r = e ? pt(t.buffer) : t.buffer;
  return new t.constructor(r, t.byteOffset, t.byteLength);
}
var En = /\w*$/;
function Mn(t) {
  var e = new t.constructor(t.source, En.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var Ct = E ? E.prototype : void 0, Et = Ct ? Ct.valueOf : void 0;
function Fn(t) {
  return Et ? Object(Et.call(t)) : {};
}
function Dn(t, e) {
  var r = e ? pt(t.buffer) : t.buffer;
  return new t.constructor(r, t.byteOffset, t.length);
}
var Ln = "[object Boolean]", Un = "[object Date]", Nn = "[object Map]", Bn = "[object Number]", Gn = "[object RegExp]", Rn = "[object Set]", qn = "[object String]", Kn = "[object Symbol]", zn = "[object ArrayBuffer]", Hn = "[object DataView]", Vn = "[object Float32Array]", Jn = "[object Float64Array]", Wn = "[object Int8Array]", Yn = "[object Int16Array]", Xn = "[object Int32Array]", Zn = "[object Uint8Array]", Qn = "[object Uint8ClampedArray]", kn = "[object Uint16Array]", ta = "[object Uint32Array]";
function ea(t, e, r) {
  var n = t.constructor;
  switch (e) {
    case zn:
      return pt(t);
    case Ln:
    case Un:
      return new n(+t);
    case Hn:
      return Cn(t, r);
    case Vn:
    case Jn:
    case Wn:
    case Yn:
    case Xn:
    case Zn:
    case Qn:
    case kn:
    case ta:
      return Dn(t, r);
    case Nn:
      return new n();
    case Bn:
    case qn:
      return new n(t);
    case Gn:
      return Mn(t);
    case Rn:
      return new n();
    case Kn:
      return Fn(t);
  }
}
function ra(t) {
  return typeof t.constructor == "function" && !it(t) ? Ce(Xt(t)) : {};
}
var na = "[object Map]";
function aa(t) {
  return z(t) && lt(t) == na;
}
var Mt = M && M.isMap, oa = Mt ? st(Mt) : aa, ia = "[object Set]";
function sa(t) {
  return z(t) && lt(t) == ia;
}
var Ft = M && M.isSet, ca = Ft ? st(Ft) : sa, ua = 1, fa = 2, la = 4, ee = "[object Arguments]", pa = "[object Array]", ga = "[object Boolean]", da = "[object Date]", ha = "[object Error]", re = "[object Function]", ba = "[object GeneratorFunction]", ya = "[object Map]", _a = "[object Number]", ne = "[object Object]", Ta = "[object RegExp]", va = "[object Set]", ja = "[object String]", ma = "[object Symbol]", $a = "[object WeakMap]", Oa = "[object ArrayBuffer]", wa = "[object DataView]", Aa = "[object Float32Array]", Sa = "[object Float64Array]", Pa = "[object Int8Array]", Ia = "[object Int16Array]", xa = "[object Int32Array]", Ca = "[object Uint8Array]", Ea = "[object Uint8ClampedArray]", Ma = "[object Uint16Array]", Fa = "[object Uint32Array]", c = {};
c[ee] = c[pa] = c[Oa] = c[wa] = c[ga] = c[da] = c[Aa] = c[Sa] = c[Pa] = c[Ia] = c[xa] = c[ya] = c[_a] = c[ne] = c[Ta] = c[va] = c[ja] = c[ma] = c[Ca] = c[Ea] = c[Ma] = c[Fa] = !0;
c[ha] = c[re] = c[$a] = !1;
function J(t, e, r, n, s, i) {
  var o, f = e & ua, l = e & fa, g = e & la;
  if (r && (o = s ? r(t, n, s, i) : r(t)), o !== void 0)
    return o;
  if (!H(t))
    return t;
  var L = ot(t);
  if (L) {
    if (o = xn(t), !f)
      return Ee(t, o);
  } else {
    var _ = lt(t), w = _ == re || _ == ba;
    if (Ht(t))
      return gn(t, f);
    if (_ == ne || _ == ee || w && !s) {
      if (o = l || w ? {} : ra(t), !f)
        return l ? Tn(t, ln(o, t)) : yn(t, fn(o, t));
    } else {
      if (!c[_])
        return s ? t : {};
      o = ea(t, _, f);
    }
  }
  i || (i = new D());
  var T = i.get(t);
  if (T)
    return T;
  i.set(t, o), ca(t) ? t.forEach(function(d) {
    o.add(J(d, e, r, d, t, i));
  }) : oa(t) && t.forEach(function(d, h) {
    o.set(h, J(d, e, r, h, t, i));
  });
  var U = g ? l ? jn : vn : l ? ut : ct, v = L ? void 0 : U(t);
  return Me(v || t, function(d, h) {
    v && (h = d, d = t[h]), Gt(o, h, J(d, e, r, h, t, i));
  }), o;
}
var Da = 1, La = 4;
function B(t) {
  return J(t, Da | La);
}
const at = [];
function Ua(t) {
  const { transformRequest: e, data: r, headers: n } = t;
  if (!t._requestId && e)
    if (typeof e == "function") {
      const s = (e == null ? void 0 : e.call(t, r, n)) || r;
      return JSON.stringify(s);
    } else {
      const s = Object.keys(e).reduce((i, o, f) => {
        const l = e[o];
        return f === 0 && (i = l.call(t, r, n)), i;
      }, null);
      return JSON.stringify(s);
    }
  else
    return JSON.stringify(r);
}
function Na(t) {
  const e = new URL(t.url, t.baseURL), r = e.protocol + "//" + e.hostname + e.pathname, n = Ua(t), s = B(t.params || {});
  e.searchParams.forEach((o, f) => s[f] = o), at.length && at.forEach((o) => {
    delete s[o];
  });
  const i = t.method;
  return JSON.stringify({ fullURL: r, data: n, params: s, method: i });
}
function Ba(t) {
  return !!(t != null && t.status) && t.status >= 500 && t.status < 600;
}
function Ga(t) {
  return t.status >= 200 && t.status < 300;
}
function qa(t) {
  const e = oe.create(), { axios: r, useCache: n, useDebounce: s, useTimestamp: i, useRetry: o, useChange: f } = t, l = t.getKey || Na, g = n !== !0 && (n == null ? void 0 : n.isSuccess) || Ga, L = o !== !0 && (o == null ? void 0 : o.isRetry) || Ba, _ = i && i !== !0 && i.timestampKey ? i.timestampKey : "timestamp";
  at.push(_);
  const w = /* @__PURE__ */ new Map(), T = /* @__PURE__ */ new Map();
  let U = 1;
  const v = /* @__PURE__ */ new Map();
  function d() {
    if (f) {
      let a = [];
      v.forEach((b) => a.push(b.config)), f.requestListChange(a);
    }
  }
  const h = /* @__PURE__ */ new Set();
  r.interceptors.request.use((a) => {
    var Z;
    if (a._requestId) {
      const C = B(a);
      e.request(C);
      const V = v.get(a._requestId);
      return V && (a.adapter = () => V.promise), a;
    }
    const b = l(a);
    if (n && a._cache) {
      const C = w.get(b);
      if (C)
        return a.adapter = () => Promise.resolve(C), a;
    }
    const y = T.get(b);
    if (s && !a._noDebounce && y)
      return a.adapter = () => y.promise, a;
    const p = B(a);
    p._requestId = U, i && ((Z = p.method) == null ? void 0 : Z.toUpperCase()) === "GET" && (p.params ? p.params[_] = (/* @__PURE__ */ new Date()).getTime() : p.params = { [_]: (/* @__PURE__ */ new Date()).getTime() }), e.request(p);
    let j, O;
    const x = new Promise((C, V) => {
      j = C, O = V;
    });
    return j && O && v.set(U, { promise: x, reject: O, resolve: j, config: p }), s && !a._noDebounce && !y && j && O && T.set(b, { promise: x }), d(), U++, a.adapter = () => x, a;
  }), e.interceptors.response.use((a) => {
    const b = a.config._requestId;
    if (b) {
      if (o && a && L(a))
        return h.add(a.config), a;
      const y = B(a);
      delete y.config._requestId;
      const p = l(a.config);
      s && !a.config._noDebounce && (T.get(p) ? T.delete(p) : (console.log("找不到请求对应key"), console.log(p), console.log(T))), n && g(a) && (a.config._cache && (a._delCache = () => w.delete(p), w.set(p, y)), a.config._delCache && a.config._delCache(w));
      const j = v.get(b);
      j && (j.resolve(y), v.delete(b), d());
    }
    return a;
  }, (a) => {
    var p, j;
    if (!a.config)
      return;
    const b = l(a.config), y = (p = a.config) == null ? void 0 : p._requestId;
    if (y) {
      const O = B(a);
      if (o && a.response && L(a.response))
        return h.add(a.config), a;
      const x = v.get(y);
      (j = O.config) == null || delete j._requestId, x && (x.reject(O), v.delete(y), d()), T.get(b) && T.delete(b);
    }
    return a;
  });
  function ae() {
    h.forEach((a) => {
      e.request(a);
    }), h.clear();
  }
  return {
    doRetry: ae
  };
}
export {
  Na as innerGetKey,
  Ba as innerIsRetry,
  Ga as innerIsSuccess,
  qa as useInterceptor
};



//////////////////
// WEBPACK FOOTER
// ./~/axios-interceptor/dist/axios-interceptor.js
// module id = 503
// module chunks = 67